const INDUSTRY_TILE_WRAPPER_MOBILE_HEIGHT = 74;
export const TEN_INDUSTRY_TILES_MOBILE_HEIGHT = INDUSTRY_TILE_WRAPPER_MOBILE_HEIGHT * 10;
